import { render, staticRenderFns } from "./AssetsItem.vue?vue&type=template&id=44486218&scoped=true&"
import script from "./AssetsItem.vue?vue&type=script&lang=js&"
export * from "./AssetsItem.vue?vue&type=script&lang=js&"
import style0 from "./AssetsItem.vue?vue&type=style&index=0&id=44486218&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44486218",
  null
  
)

export default component.exports